
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { Folder } from "@/models/tasks/folder";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		folder: {
			type: Object as () => Folder,
			required: true
		},
		canEdit: {
			type: Boolean
		},
		showCompleted: {
			type: Boolean
		}
	},
	computed: {
		title():string {
			return this.folder.Name;
		},
		toggleTasksText(): string {
			if (this.showCompleted) {
				return this.$ct("hide-completed").toString();
			}
			return this.$ct("show-completed").toString();
		},
		addDropdownItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("normal-task"),
					value: this.addItem,
					icon: "tasks"
				},
				{
					text: this.$ct("repeated-task"),
					value: this.addRepeatedTask,
					icon: "calendar"
				}
			];
		}
	},
	methods: {
		toggleCompleted() {
			this.$emit("toggle-completed");
		},
		addItem() {
			this.$emit("add-item");
		},
		addRepeatedTask(){
			this.$emit("add-repeated");
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
